<template>
  <div id="addSocialContactWindow">
    <el-dialog title="编辑社交信息" :visible.sync="dialogVisible" width="600px">
      <div class="dialog-body" style="border-top: 1px solid #e5e5e5;">
        <div class="panel-body-row">
          <div class="panel-body-row-left">微博账号:</div>
          <div class="panel-body-row-right">
            <el-input v-model="currEditSocialContact.wbId" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">微信账号：</div>
          <div class="panel-body-row-right">
            <el-input v-model="currEditSocialContact.wxId" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
      </div>
      <div class="dialog-footer eb-button-group" slot="footer" style="border-top: 1px solid #e5e5e5;margin-top: 100px;">
        <el-button :loading="buttonLoading" @click="closeMyDialog()" class="eb-button-group-btn eb-button-orange eb-button-big">取消</el-button>
        <el-button :loading="buttonLoading" @click="editSocialContact()" class="eb-button-group-btn eb-button-orange eb-button-big">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
export default {
  name: 'addSocialContactWindow',
  props: {
    orgInfo: {}
  },
  data() {
    return {
      dialogVisible: false,
      buttonLoading: false,
      currEditSocialContact: {}
    };
  },
  created() {
    eventBus.$on('showEditSocialContactWindow', params => {
      this.dialogVisible = true;
      this.currEditSocialContact = params;
    });
  },
  methods: {
    editSocialContact() {
      this.orgInfo.wbId = this.currEditSocialContact.wbId;
      this.orgInfo.wxId = this.currEditSocialContact.wxId;
      this.dialogVisible = false;
    },
    closeMyDialog() {
      this.dialogVisible = false;
    }
  }
};

</script>
<style scoped lang="less">

</style>
